export default "__VITE_ASSET__5a3710b0__"